// TODO: @HTML5 use a native JS library to access browser cookies
// import SharedObject = createjs.SharedObject;

/**
 * Helper for saving SharedObjects and handling the possible errors.
 *
 * This class uses no Logger on purpose because it's also used with the CookieSaver.swf which filesize should stay as low as possible.
 */
export class CookieHelper {
    /*
     *	Copies all properties of a SharedObject into another SharedObject
     */
    public static copyCookie(sourceCookie: any, targetCookie: any): void {
        // TODO: @HTML5 use a native JS library to access browser cookies
        /*
        if (sourceCookie && targetCookie) {
            for (let property: string in sourceCookie.data) {
                targetCookie.data[property] = sourceCookie.data[property];
            }
        }
        */
    }

    /*
     *	Checks if a cookie is empty (does not contain any properties)
     */
    public static isCookieEmpty(cookie: any): boolean {
        let isEmpty: boolean = true;

        // TODO: @HTML5 use a native JS library to access browser cookies
        /*
        for (let s: string in cookie.data) {
            isEmpty = false;
            break;
        }
        */

        return isEmpty;
    }
}
